<template>
    <div class="ruihong-pc">
        <!-- header -->
        <div class="header">
            <div class="container1">
                <img class="logo" src="@/assets/images/logo_ruihong.png" alt=""/>
                <div class="menu">
                    <div class="item"><router-link to="/">首页</router-link></div>
                    <template v-for="(item, index) in menu">
                        <div class="item" :key="index" @click="menuTap(item.anchor)">{{item.name}}</div>
                    </template>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="banner">
                <img src="@/assets/images/ruihong_banner_01.jpg" alt=""/>
                <div class="form_wrap" :class="{active: isShowForm}">
                    <div class="close" @click="isShowForm = false"></div>
                    <a class="tel_btn" :href="`tel:+021-23063921`"><div class="icon"></div>立即咨询</a>
                    <div class="container1">
                        <div class="close" @click="isShowForm = false"></div>
                        <div class="form">
                            <p class="title">我们将尽快与您联系请填写以下信息</p>
                            <input type="text" placeholder="姓名" v-model="form.name">
                            <input type="text" placeholder="电话" v-model="form.phone" maxlength="11">
                            <p class="title type1">请填写您的留言</p>
                            <input type="text" v-model="form.content">
                            <div class="btn" @click="submit">提交</div>
                            <div class="tel"><div class="icon"></div>租赁热线：021-23063921</div>
                        </div>
                    </div>
                </div>
            </div>
            <img src="@/assets/images/ruihong_01.jpg" alt="" id="box1"/>
            <img src="@/assets/images/ruihong_02.jpg" alt=""/>
            <img src="@/assets/images/ruihong_03.jpg" alt=""/>
            <img src="@/assets/images/ruihong_04.jpg" alt="" id="box2"/>
            <img src="@/assets/images/ruihong_05.jpg" alt=""/>
            <Swiper :data="swiper"/>
            <img src="@/assets/images/ruihong_06.jpg" alt="" id="box3"/>
            <img src="@/assets/images/ruihong_07.jpg" alt=""/>
            <img src="@/assets/images/ruihong_08.jpg" alt=""/>
            <img src="@/assets/images/ruihong_09.jpg" alt=""/>
            <img src="@/assets/images/ruihong_10.jpg" alt="" id="box4"/>
            <!-- brand end -->
            <div class="other">
                <div class="container">
                    <div class="content_title">瑞安办公其他项目推荐</div>
                    <Other :data="other_list"/>
                </div>
            </div>
        </div>
        <!-- footer -->
        <div class="footer">
            <div class="container1">
                <img class="logo" src="@/assets/images/logo_ruihong2.png" alt=""/>
                <div class="info">
                    <img class="logo2" src="@/assets/images/logo_ruihong3.png" alt=""/>
                    <p>021-55957878<br/>上海市虹口区飞虹路118号<br/><a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备14039754号-11</a></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from '../../components/ruihong/swiper.vue';
import Other from '../../components/ruihong/other2.vue';
import config from '../../config';
export default {
    name: "ruihong-pc",
    data() {
        return {
            menu: [
                { name: '区域交通', anchor: 'box1' },
                { name: '理想有温度', anchor: 'box2' },
                { name: '技术参数', anchor: 'box3' },
                { name: '关于我们', anchor: 'box4' },
            ],
            showMenu: false,
            loading: true,
            isShowForm: false,
            form: {
                name: '',
                phone: '',
                content: ''
            },
            other_list: [],
            swiper: [
                require('@/assets/images/ruihong_swiper_01.jpg'),
                require('@/assets/images/ruihong_swiper_02.jpg'),
                require('@/assets/images/ruihong_swiper_03.jpg'),
                require('@/assets/images/ruihong_swiper_04.jpg'),
                require('@/assets/images/ruihong_swiper_05.jpg'),
                require('@/assets/images/ruihong_swiper_06.jpg'),
                require('@/assets/images/ruihong_swiper_07.jpg'),
            ],
        };
    },
    computed: {},
    components: {
        Other,
        Swiper,
    },
    mounted() {
        this.getOther();
    },
    watch: {},
    methods: {
        menuTap(anchor){
            let dom = document.getElementById(anchor);
            let headerH = document.getElementsByClassName('header')[0].offsetHeight;
            if(dom){
                window.scrollTo(0, this.getElementTop(dom) - headerH)
            }
        },
        getElementTop(element){
            var actualTop = element.offsetTop;
            var current = element.offsetParent;
            while (current !== null){
                actualTop += current.offsetTop;
                current = current.offsetParent;
            }
            return actualTop;
        },
        submit(){
            let self = this;
            if(this.upinfo){
                return false;
            }
            if(this.form.name.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                self.$showToast({
                    text: '姓名不能为空'
                })
                return false;
            }
            if(this.form.phone.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                self.$showToast({
                    text: '电话不能为空'
                })
                return false;
            }
            if(!(/^1[3-9]\d{9}$/.test(this.form.phone))){
                self.$showToast({
                    text: '手机号码格式有误'
                })
                return false;
            }
            if(this.form.content.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                self.$showToast({
                    text: '留言不能为空'
                })
                return false;
            }
            this.upinfo = true;
            this.$showLoading();
            this.axios.get(config.message, {
                params: {
                    id: 9,
                    name: this.form.name,
                    phone: this.form.phone,
                    content: this.form.content
                }
            })
            .then((result) => {
                self.upinfo = false;
                self.$hideLoading();
                if(result.data.code == 100){
                    self.form = { name: '', phone: '', content: '' };
                    self.$showToast({text: '提交成功'})
                }else{
                    self.$showToast({text: '提交失败，请稍后再试'})
                }
            }).catch((err) => {
                self.upinfo = false;
                self.$hideLoading();
                self.$showToast({text: '提交失败，请稍后再试'})
            });
        },
        getOther(){
            this.$store.dispatch('getOther', {id: 9}).then((result) => {
                this.other_list = result;
            }).catch((err) => {
                
            });
        },
    },
    destroyed() {
    },
};
</script>

<style scoped lang="scss">
.container1{
    width: 12rem;
    margin: 0 auto;
    position: relative;
}
textarea,
input{
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    outline: none;
    font-family: Arial, Helvetica, sans-serif;
    display: block;
    background: none;
    border: none;
    border-radius: 0;
}
.main{
    width: 100%;
    max-width: 19.2rem;
    margin: 0 auto;
    padding-top: 1.5rem;
    .banner{
        position: relative;
        .form_wrap{
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
            .container1{
                height: 100%;
                position: relative;
            }
            .form{
                width: 5.3rem;
                background: #2f241d;
                padding: .48rem .48rem .3rem;
                border-radius: .05rem;
                position: absolute;
                top: 50%;
                transform: translate3d(0, -50%, 0);
                font-size: .26rem;
                color: #fff;
                input{
                    width: 100%;
                    height: .54rem;
                    border-radius: .05rem;
                    padding: 0 .12rem;
                    font-size: .26rem;
                    color: #2f241d;
                    background: #d5d3d2;
                    margin-bottom: .14rem;
                    &::placeholder{
                        color: #2f241d;
                    }
                }
                .title{
                    margin-bottom: .2rem;
                    &.type1{
                        margin-top: .35rem;
                    }
                }
                .btn{
                    width: 100%;
                    height: .54rem;
                    border-radius: .05rem;
                    text-align: center;
                    font-size: .26rem;
                    line-height: .54rem;
                    color: #fff;
                    font-weight: bold;
                    background: #976a4c;
                    margin-bottom: .2rem;
                    cursor: pointer;
                }
                .tel{
                    display: flex;
                    align-items: center;
                    font-size: .2rem;
                    .icon{
                        width: .32rem;
                        height: .32rem;
                        background: url('../../assets/images/icon_tel.png') no-repeat;
                        background-size: 100% auto;
                        margin-right: .05rem;
                    }
                }
            }
            .tel_btn{
                color: #fff;
                position: absolute;
                top: .1rem;
                right: .3rem;
                display: none;
                align-items: center;
                z-index: 1;
                .icon{
                    width: .32rem;
                    height: .32rem;
                    background: url('../../assets/images/icon_tel.png') no-repeat;
                    background-size: 100% auto;
                }
            }
        }
    }
    .other{
        background: #f1f1f1;
        padding: .7rem 0;
        
        .content_title{
            font-size: .36rem;
            font-weight: bold;
            padding: .6rem 0 .3rem;
            line-height: 1;
        }
        .content_title{
            text-align: center;
            margin-bottom: .7rem;
        }
    }
}
.header{
    background: #000;
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 99;
    .container1{
        height: 1.5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .logo{
        width: 2.81rem;
    }
    .menu{
        display: flex;
        align-items: center;
        color: #fff;
        font-size: .2rem;
        .item{
            margin-left: .4rem;
            cursor: pointer;
        }
    }
}
.footer{
    background: #fff;
    .container1{
        height: 1.75rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .logo{
        width: 4.77rem;
    }
    .info{
        display: flex;
        align-items: center;
        font-size: .16rem;
        color: #454545;
        line-height: 2;
        .logo2{
            width: 1.29rem;
        }
        p{
            border-left: 1px solid #000;
            padding: .05rem 0 0 .2rem;
            margin-left: .2rem;
        }
    }
}
</style>